import { CommonAddressResponse } from './../../core/models/CommonAddressResponse';
import { Injectable, Injector } from '@angular/core';
import { ID } from '@datorama/akita';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ChannelStore } from './channel.store';
import { Channel } from './channel.model';
import { StoreMode } from 'src/app/core/enums';
import { ChannelQuery } from './channel.query';
import { CustomService } from 'src/app/core/services/custom.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import { CustomRequest } from 'src/app/core/models/CustomRequest';
import { HttpMethod } from '@datorama/akita-ng-entity-service';
import { environment } from 'src/environments/environment';
import { HttpHeaderType } from 'src/app/core/enums/HttpHeaderType';
import { User } from 'src/app/core/user/user.model';
import { UserService } from 'src/app/core/user/user.service';
import { ChannelSecService } from '../channelsec/channelsec.service';
import { ChannelData, ChannelRequest, ChannelSection } from 'src/app/core/models';
import { OrderTypeFlag } from 'src/app/core/enums/OrderTypeFlag';
import { Observable, Subject, TimeoutError } from 'rxjs';
import { ChannelCustomerResponse } from 'src/app/core/models/ChannelCustomerResponse';
import { UserQuery } from 'src/app/core/user/user.query';
import { CurrencyResponse } from 'src/app/core/models/CurrencyResponse';
import { ChannelSec } from '../channelsec/channelsec.model';
import { ChannelSectionResponseGenericDataResponse } from 'src/app/core/models/ChannelSectionResponseGenericDataResponse';
import * as _ from 'lodash';
import { TimeService } from 'src/app/core/services/time.service';
import { AddrSysFlag } from 'src/app/core/enums/AddrSysFlag';
import { StaticQrService } from 'src/app/core/static-qr/static-qr.service';
import { FilterItem } from 'src/app/core/models/local/FilterItem';
import { SetCode } from 'src/app/core/enums/SetCode';
import { SessionStorageService } from 'src/app/shared/storage/session-storage.service';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { Router } from '@angular/router';
import { ToastData } from 'src/app/core/models/ToastData';
import { ToastService } from 'src/app/shared/services/toast.service';

@Injectable({ providedIn: 'root' })
export class ChannelService {
  accessToken: string = "";
  curUser: User | null = null;
  curChannel: Channel = null;
  channelReq: ChannelRequest = {
    skip: 0,
    take: 10,
    channelTag: environment.eorderChannel,
    orderType: OrderTypeFlag.All,
    storeAttrs: undefined
  };
  selectedAddress: CommonAddressResponse;
  isUserLogin: boolean = false;
  isSubDomain: boolean = false;
  channelInfo$: Subject<any> = new Subject<any>();
  defaultCurrency: CurrencyResponse = {
    currCode: 'MYR',
    currDesc: 'malaysia countrycode',
    currPrefix: 'RM',
    currSuffix: undefined,
    rateUDF: undefined,
    lastRevDate: undefined,
    currExponent: undefined
  };
  selectedChannel: ChannelCustomerResponse = null;
  gpsLocation: any = null;
  subdomainChannelTag: string = '';
  parseURL = location.href.split("/");
  initialChannelTag: string = '';
  switchChannelResult: any;

  currentOrderType: string;
  switchChannelData: ChannelCustomerResponse;

  subscriptionTag: string | null = null;
  channelTag: string;
  pathSegments: any = [];
  private userService: UserService;

  constructor(
    private channelStore: ChannelStore,
    private http: HttpClient,
    private customService: CustomService,
    private utilsService: UtilsService,
    private channelQuery: ChannelQuery,
    private chnlsecService: ChannelSecService,
    private userQuery: UserQuery,
    private timeService: TimeService,
    private staticQrService: StaticQrService,
    private sessionStorageService: SessionStorageService,
    private analyticsService: AnalyticsService,
    private navigationService: NavigationService,
    private injector: Injector,
    private router: Router,
    private toastService: ToastService,
  ) {
    this.get(StoreMode.Internal).subscribe((channelData: Channel) => {
      if (channelData) {
        this.curChannel = channelData;
        this.recentAddressCheck(channelData);
        this.subscriptionTag = channelData.subscriptionTag;
        this.channelTag = channelData.channelTag;
      } else {
        this.initialChannelTag = localStorage.getItem('channelTag');
      }
    });

    this.getUserService()?.get(StoreMode.Internal).subscribe((userData: any) => {
      this.accessToken = userData && userData['accessToken'] ? userData['accessToken'] : '';
      this.curUser = userData ? userData : null;
      this.isUserLogin = userData ? true : false;
    });

    this.userQuery.selectedAddress$.subscribe(address => {
      this.selectedAddress = address;
      this.channelReq.latitude = address?.latitude ?? 0;
      this.channelReq.longitude = address?.longitude ?? 0;
    });
  }

  get(storeMode: StoreMode): Observable<Channel> {
    let entities = null;
    if (storeMode === StoreMode.External) {
      this.channelStore.setLoading(true);
      entities = this.http.get('https://akita.com');
      this.channelStore.setLoading(false);
    }
    return this.channelQuery.selectFirst();
  }

  add(store: Channel) {
    this.channelStore.add(store);
  }

  update(id: any, store: Channel) {
    this.channelStore.update(id, store);
  }

  remove(id: ID) {
    this.channelStore.remove(id);
  }

  clear() {
    if (!this.curChannel) {
      return;
    }
    this.remove(this.curChannel.id);
  }

  error(err: any) {
    this.channelStore.setError(err);
  }

  destroy() {
    this.channelStore.destroy();
  }

  getChannelId() {
    return this.curChannel.channelId;
  }

  getChannelData() {
    return this.curChannel?.data;
  }

  getChannelTag() {
    return this.curChannel?.channelTag;
  }

  getSubscriptionTag() {
    return this.curChannel?.subscriptionTag;
  }

  getSegments() {
    return this.pathSegments;
  }

  async getChannelDataCheck() {

    if (this.curChannel && this.curChannel.channelId) {
      return await this.curChannel;
    } else {
      await this.switchChannelVerify(false);
      return this.curChannel;
    }
  }

  async recallGetChannelData() {
    await this.switchChannelVerify();
  }

  async switchChannelVerify(getChannel: boolean = true) {
    this.switchChannelResult = await this.switchChannelCheck();
    if (this.switchChannelResult instanceof TimeoutError) {
      return;
    }

    if (this.switchChannelResult instanceof HttpErrorResponse) {
      if (this.switchChannelResult['status'] !== 400 && this.switchChannelResult['error']['detail'] !== 'SystemMaintenance_400' && this.switchChannelResult['status'] !== 401) {
        this.navigationService.navigate(['channel-not-found']);
      }
    } else {
      await this.staticQrService.staticDataClearCheck(this.switchChannelResult.channelId);
      // await this.switchChannelClearCheck();

      if (getChannel) {
        this.curChannel = {
          ...this.curChannel,
          channelId: this.switchChannelResult.channelId
        };

        if (this.switchChannelResult.addrSysFlag === AddrSysFlag.Predefined && !this.selectedAddress) {
          this.selectedAddress = null;
        }
        await this.getChannel(this.curChannel);
      }
      else {
        return this.switchChannelResult;
      }
    }
  }

  async switchChannelClearCheck() {
    let currentTag = localStorage.getItem('channelTag');
    if (currentTag) {
      let channelTag = this.isSubDomain ? this.subdomainChannelTag : this.parseURL[3];
      if (channelTag.toLowerCase() != currentTag.toLowerCase()) {
        this.staticQrService.remove();
        this.staticQrService.removeChannelOrderType();
      }
    }
  }

  async setupStaticQr() {
    let staticQr = this.staticQrService.get();
    if (staticQr && staticQr?.orderType) {
      this.channelReq = { ...this.channelReq, orderType: staticQr.orderType };
    }
  }

  private setActive(tizId: number) {
    this.channelStore.setActive(tizId);
  }

  // using
  async getChannel(channelReq?: Partial<ChannelRequest>) {
    let respDt = null;

    if (channelReq) {
      this.channelReq.channelTag = channelReq.channelTag;
    }

    // get order type store in sessions storage if it existed
    let channelOrderType = this.staticQrService.getChannelOrderType();
    if (!channelOrderType) {
      channelOrderType = this.staticQrService.getOrderTypeFromurl();
    }

    await this.filterAttrVerify();

    let tempSelectedOrdertype = JSON.parse(this.sessionStorageService.getItem('tempOrderType'));

    let reqDt: ChannelRequest = {
      ...this.channelReq,
      latitude: this.selectedAddress?.latitude ?? this.channelReq.latitude ?? 0,
      longitude: this.selectedAddress?.longitude ?? this.channelReq.longitude ?? 0,
      ...channelReq,
      orderType: tempSelectedOrdertype ?? channelOrderType ?? OrderTypeFlag.All
    };
    respDt = await this.reqChannelData(this.accessToken, reqDt.latitude, reqDt.longitude, reqDt.skip, reqDt.take,
      reqDt.channelId, reqDt.channelTag, reqDt.orderType, reqDt.storeAttrs, reqDt.minPrice, reqDt.maxPrice, reqDt.rate);

    if (respDt instanceof HttpErrorResponse === false) {
      this.addChannel(respDt['data'], reqDt);
      localStorage.setItem('channelTag', respDt['data'].channelTag);
      localStorage.setItem('countryCode', respDt['data'].countryCode);
    } else {
      this.navigationService.navigate(['channel-not-found']);
    }

    return respDt;
  }

  async switchChannel(channelTag?: string, channelId?: string, countryCode?: string, subscriptionID?: string, subscriptionTag?: string): Promise<ChannelCustomerResponse> {
    let respDt = null;
    respDt = await this.reqSwitchChannel(this.accessToken, channelTag, channelId, countryCode, subscriptionID, subscriptionTag);

    if (respDt instanceof HttpErrorResponse === false) {
      this.addChannel(respDt, respDt);
      localStorage.setItem('channelTag', respDt.channelTag);
      localStorage.setItem('countryCode', respDt.countryCode);
    } else {
      this.router.navigateByUrl('/');
    }

    return respDt;
  }

  async getHomeChannelSection(homeSecId: number, skip: number, take: number): Promise<ChannelSectionResponseGenericDataResponse> {
    let respDt = null;

    await this.filterAttrVerify();

    let reqDt: ChannelRequest = {
      ...this.channelReq,
      latitude: this.selectedAddress?.latitude ?? this.channelReq.latitude ?? 0,
      longitude: this.selectedAddress?.longitude ?? this.channelReq.longitude ?? 0,
      homeSecId: homeSecId,
    };

    respDt = await this.reqHomeChannelSection(this.accessToken, reqDt.latitude, reqDt.longitude, skip, take,
      this.curChannel.channelId, homeSecId, this.curChannel.orderType, this.curChannel.channelTag, reqDt.storeAttrs, undefined, reqDt.minPrice, reqDt.maxPrice, reqDt.rate);
    return respDt;
  }

  async getPlaceAutoComplete(channelTag: string, keyword: string): Promise<CommonAddressResponse[]> {
    let respDt = null;
    respDt = await this.reqPlaceAutoComplete(this.accessToken, channelTag, keyword);
    return respDt;
  }

  async getPlaceDetail(addressId: string, type: string): Promise<CommonAddressResponse | null> {
    let respDt = null;
    respDt = await this.reqPlaceDetail(this.accessToken, addressId, type);
    if (respDt instanceof (HttpErrorResponse)) {
      let toastData = {} as ToastData;
      toastData.failStatus = true;
      toastData.message = respDt.error.title
      this.toastService.show(toastData);
      return null;
    } else {
      return respDt;
    }

  }

  async getLocationAddress(longitude: number, latitude: number, channelId?: number): Promise<CommonAddressResponse | HttpErrorResponse> {
    let respDt = null;
    let currentChannelId = channelId ? channelId : this.curChannel ? this.curChannel.channelId : 1;
    respDt = await this.reqGetLocationAddress(this.accessToken, longitude, latitude, currentChannelId);
    return respDt;
  }

  async resolveLocationAddress(longitude: number, latitude: number, channelId?: number): Promise<CommonAddressResponse | null> {
    const locationAddress = await this.getLocationAddress(longitude, latitude, channelId);
    if (!locationAddress || locationAddress instanceof HttpErrorResponse || !locationAddress.fullAddress) {
      return null;
    }

    return {
      ...locationAddress,
      // Always preserve the coordinates obtained from the browser.
      longitude,
      latitude
    };
  }

  async getInfoPanelData(infoId: number) {
    let respDt = null;
    respDt = await this.reqGetInfoPanelData(this.accessToken, infoId);
    return respDt;
  }

  private async reqChannelData(accessToken: string, latitude: number, longitude: number, skip?: number, take?: number,
    channelId?: number, channelTag: string = environment.eorderChannel, orderType: string = 'All', storeAttrs?: string,
    minPrice?: number, maxPrice?: number, rates?: number) {
    let newCr = {
      httpMethod: HttpMethod.GET,
      requestpath: environment.apis.channel.GetChannelData,
      hostPath: environment.hostPath,
      headers: {
        accessToken: accessToken
      },
      queryParams: {
        latitude: latitude ? latitude : 0,
        longitude: longitude ? longitude : 0,
        skip: skip,
        take: take,
        channelId: channelId,
        channelTag: channelTag,
        orderType: orderType,
        storeAttrs: storeAttrs,
        minPrice: minPrice,
        maxPrice: maxPrice,
        rates: rates ? rates : undefined,
      },
      httpHeaderType: this.accessToken ? HttpHeaderType.Auth : HttpHeaderType.Normal
    } as CustomRequest;
    let respInfo = null;
    this.channelStore.setLoading(true);
    respInfo = await this.reqCustomHttpCall(newCr);
    this.channelStore.setLoading(false);
    return respInfo;
  }

  private async reqSwitchChannel(accessToken: string, channelTag: string, channelId?: string, countryCode?: string, subscriptionID?: string, subscriptionTag?: string) {
    let newCr = {
      httpMethod: HttpMethod.POST,
      requestpath: environment.apis.channel.SwitchChannel,
      hostPath: environment.hostPath,
      headers: {
        accessToken: accessToken,
        subTag: subscriptionTag
      },
      queryParams: {
        channelTag: channelTag,
        channelId: channelId,
        countryCode: countryCode
      },
      httpHeaderType: HttpHeaderType.Auth
    } as CustomRequest;
    let respInfo = null;
    this.channelStore.setLoading(true);
    respInfo = await this.reqCustomHttpCall(newCr);
    this.channelStore.setLoading(false);
    return respInfo;
  }

  private async reqHomeChannelSection(accessToken: string, latitude: number, longitude: number, skip: number, take: number,
    channelId: number, homeSectionId: number, orderType?: string, channelTag?: string, storeAttrs?: string, excludeMerchantIds?,
    minPrice?: number, maxPrice?: number, rates?: number) {
    let newCr = {
      httpMethod: HttpMethod.GET,
      requestpath: environment.apis.channel.GetChannelHomeSection,
      hostPath: environment.hostPath,
      headers: {
        accessToken: accessToken
      },
      queryParams: {
        latitude: latitude,
        longitude: longitude,
        skip: skip,
        take: take,
        channelId: channelId,
        homeSectionId: homeSectionId,
        orderType: orderType,
        channelTag: channelTag,
        storeAttrs: storeAttrs,
        excludeMerchantIds: excludeMerchantIds,
        minPrice: minPrice,
        maxPrice: maxPrice,
        rates: rates
      },
      httpHeaderType: HttpHeaderType.Auth
    } as CustomRequest;
    let respInfo = null;
    this.channelStore.setLoading(true);
    respInfo = await this.reqCustomHttpCall(newCr);
    this.channelStore.setLoading(false);
    return respInfo;
  }

  private async reqPlaceAutoComplete(accessToken: string, channelTag: string, keyword: string): Promise<CommonAddressResponse[]> {
    let newCr = {
      httpMethod: HttpMethod.GET,
      requestpath: environment.apis.channel.PlaceAutoComplete,
      hostPath: environment.hostPath,
      headers: {
        accessToken: accessToken,
      },
      queryParams: {
        ChannelTag: channelTag,
        keyword: keyword
      },
      httpHeaderType: HttpHeaderType.Auth
    } as CustomRequest;
    let respInfo = null;
    this.channelStore.setLoading(true);
    respInfo = await this.reqCustomHttpCall(newCr);
    this.channelStore.setLoading(false);
    return respInfo;
  }

  private async reqPlaceDetail(accessToken: string, addressId: string, type: string): Promise<CommonAddressResponse> {
    let newCr = {
      httpMethod: HttpMethod.GET,
      requestpath: environment.apis.channel.GetPlaceDetails,
      hostPath: environment.hostPath,
      headers: {
        accessToken: accessToken,
      },
      queryParams: {
        addressid: addressId,
        type: type
      },
      httpHeaderType: HttpHeaderType.Auth
    } as CustomRequest;
    let respInfo = null;
    this.channelStore.setLoading(true);
    respInfo = await this.reqCustomHttpCall(newCr);
    this.channelStore.setLoading(false);
    return respInfo;
  }

  private async reqGetLocationAddress(accessToken: string, longtitude: number, latitude: number, channelId: number): Promise<CommonAddressResponse> {
    let newCr = {
      httpMethod: HttpMethod.GET,
      requestpath: environment.apis.channel.GetlocationAddress,
      hostPath: environment.hostPath,
      headers: {
        accessToken: accessToken,
      },
      queryParams: {
        longtitude: longtitude,
        latitude: latitude,
        channelId: channelId
      },
      httpHeaderType: HttpHeaderType.Auth
    } as CustomRequest;
    let respInfo = null;
    this.channelStore.setLoading(true);
    respInfo = await this.reqCustomHttpCall(newCr);

    if (respInfo instanceof HttpErrorResponse === false) {
      this.analyticsService.locationRequestEvent();
    }

    this.channelStore.setLoading(false);
    return respInfo;
  }

  private async reqGetInfoPanelData(accessToken: string, infoId: number) {
    let newCr = {
      httpMethod: HttpMethod.GET,
      requestpath: environment.apis.infoPanel.GetInfoPanelData,
      hostPath: environment.hostPath,
      headers: {
        accessToken: accessToken,
        channelTag: this.curChannel.channelTag
      },
      queryParams: {
        infoId: infoId
      },
      httpHeaderType: HttpHeaderType.Auth
    } as CustomRequest;

    let respInfo = null;
    respInfo = await this.reqCustomHttpCall(newCr);
    return respInfo;
  }

  private reqCustomHttpCall(cusreq: CustomRequest) {
    const cSv = this.customService;
    return cSv.createRequest(cusreq).then((dd: any) => {
      if (dd && dd.headers) {
        this.timeService.setServerTime(dd.headers.get("X-ServerDateTime"));
        this.timeService.calculateServerTimeDifference();
      }
      return dd && dd['body'] ? dd['body'] : dd
    });
  }

  private formatSrvDateStr(date: Date) {
    const utilSv = this.utilsService;
    return utilSv.formatSrvDateStr(date);
  }

  getCurrentChannel(): Channel {
    return this.curChannel;
  }


  // Using
  private addChannel(data: any, channelReq?: Partial<ChannelRequest>) {
    const chnsecSv = this.chnlsecService;
    const chnDt = data as ChannelData;
    const chnsecDt = chnDt.channelHomeSections as ChannelSection[] ?? [];

    if (!(this.curUser)) {
      this.curUser = { id: environment.localGenCustomerId } as User;
    }

    const fmtDt = chnsecDt.map(dd => {
      let nDt = {
        id: (this.curUser?.id || environment.localGenCustomerId) + "-" + chnDt.channelId + "-" + chnDt.channelTag + "-" + dd.sectionId,
        channelCode: chnDt.channelCode,
        channelId: chnDt.channelId,
        channelTag: chnDt.channelTag,
        subscriptionTag: this.subscriptionTag,
        secId: dd.sectionId,
        data: dd,
        pathSegments: this.pathSegments,
        isSubDomain: this.isSubDomain,
      };
      nDt = chnsecSv.format(nDt) as any;
      return nDt;
    });

    chnDt.channelHomeSections = fmtDt as ChannelSec[];

    if (!chnDt.currency) {
      chnDt.currency = this.defaultCurrency;
    }

    this.channelStore.remove();
    this.channelStore.upsert(this.curUser.id, {
      id: this.curUser.id || environment.localGenCustomerId,
      channelCode: chnDt.channelCode,
      channelId: chnDt?.channelId,
      subscriptionTag: this.subscriptionTag,
      channelTag: chnDt.channelTag,
      orderType: channelReq && channelReq.orderType ? channelReq.orderType : 'All',
      data: chnDt,
      pathSegments: this.pathSegments,
      isSubDomain: this.isSubDomain,
    });

    if (chnDt.channelHomeSections.length > 0) {
      chnsecSv.resetChannelHomeSection(chnDt.channelHomeSections);
    }
  }

  async updateChannelData(channelDataResponse: ChannelSectionResponseGenericDataResponse) {
    let chnHmSecData = this.curChannel.data.channelHomeSections as ChannelSec[];
    let matchIndex = chnHmSecData.findIndex(data => data.secId === channelDataResponse.data.sectionId);

    let currentStoreData = this.curChannel.data.channelHomeSections[matchIndex].data['data_1'];
    let incomingStoreData = channelDataResponse.data['data_1'];
    let combinedStoreData = _.concat(currentStoreData, incomingStoreData);

    let newCurChannel: any = _.cloneDeep(this.curChannel);
    newCurChannel.data.channelHomeSections[matchIndex].data.data[1].dataSet = _.cloneDeep(combinedStoreData);
    newCurChannel.data.channelHomeSections[matchIndex].data['data_1'] = _.cloneDeep(combinedStoreData);

    if (newCurChannel) {
      this.channelStore.upsert(this.curUser.id, {
        id: this.curUser.id || environment.localGenCustomerId,
        channelCode: this.curChannel.channelCode,
        channelId: this.curChannel?.channelId,
        channelTag: this.curChannel.channelTag,
        orderType: this.curChannel.orderType,
        data: newCurChannel.data
      });
    }
  }

  getSwitchChannel() {
    return this.channelInfo$.asObservable();
  }

  triggerSwitchChannel(channelId: string, channelTag: string) {
    this.channelInfo$.next({ channelId, channelTag });
  }

  async switchChannelCheck() {
    const resolvedChannelTag = this.channelTag || this.getChannelTagFromUrl();
    return await this.switchChannel(resolvedChannelTag, undefined, undefined, undefined, this.subscriptionTag);
  }

  /** Reads the channel tag from the current URL path segments as a last-resort fallback. */
  private getChannelTagFromUrl(): string {
    const segments = window.location.pathname.split('/').filter(Boolean);
    // URL structure: /<subscriptionTag>/<channelTag>/home  (or subdomain: /<channelTag>/home)
    // When isSubDomain the channelTag is at index 0, otherwise at index 1.
    const hostParts = window.location.hostname.split('.');
    const isSubDomain = hostParts.length > 2 && hostParts[0] !== environment.hostName;
    return isSubDomain ? segments[0] : segments[1];
  }

  recentAddressCheck(channelData: Channel) {
    if (this.initialChannelTag && this.initialChannelTag !== channelData.channelTag) {
      localStorage.removeItem('recent-address');
    }
  }

  async filterAttrVerify() {
    let filterItem: FilterItem = JSON.parse(this.sessionStorageService.getItem('filter-item'));
    if (filterItem) {
      this.channelReq = {
        ...this.channelReq,
        storeAttrs: filterItem?.storeAttrs ? filterItem.storeAttrs : undefined,
        minPrice: filterItem?.minPrice ? filterItem.minPrice : undefined,
        maxPrice: filterItem?.maxPrice ? filterItem.maxPrice : undefined,
        rate: filterItem?.rate ? filterItem.rate : undefined
      }
    } else {
      this.channelReq = {
        ...this.channelReq,
        storeAttrs: undefined,
        minPrice: undefined,
        maxPrice: undefined,
        rate: undefined,
      }
    }
  }

  getPlatformSetValue(setCode: SetCode) {
    return this.curChannel.data.platformSets.find(pFormSet => pFormSet.setCode === setCode);
  }

  setCurrentOrderType(orderType: string) {
    this.currentOrderType = orderType;
  }

  getCurrentOrderType() {
    return this.currentOrderType ? this.currentOrderType : OrderTypeFlag.All;
  }

  async getOrderTypeCount(data): Promise<number> {
    if (!data) {
      return 0;
    }

    let orderTypeCount: number = 0;

    if (data.deliveryFlag) {
      orderTypeCount++;
    }

    if (data.pickupFlag) {
      orderTypeCount++;
    }

    if (data.dineFlag && environment.enableDineIn) {
      orderTypeCount++;
    }

    return orderTypeCount;
  }

  async getOrderTypeWhenOnlyOneType(channelData) {
    let currentOrderType: string = OrderTypeFlag.All;

    if (channelData.deliveryFlag) {
      currentOrderType = OrderTypeFlag.Delivery;
    }

    if (channelData.pickupFlag) {
      currentOrderType = OrderTypeFlag.Pickup;
    }

    if (channelData.dineFlag && environment.enableDineIn) {
      currentOrderType = OrderTypeFlag.DineIn;
    }

    return currentOrderType;
  }

  setSwitchChannelData(channelData: ChannelCustomerResponse) {
    this.switchChannelData = channelData;
  }

  getSwitchChannelData() {
    return this.switchChannelData ? this.switchChannelData : null;
  }

  setSubChannel(subscriptionTag: string, channelTag: string) {
    const hostParts = window.location.hostname.split('.');

    this.subscriptionTag = subscriptionTag;
    this.channelTag = channelTag;

    // update custom service
    this.customService.updateSubTag(subscriptionTag);

    // update channel store
    this.isSubDomain = (hostParts.length > 2 && hostParts[0] !== environment.hostName);
    const pathSegments = [];
    if (this.isSubDomain) {
      pathSegments.push(this.channelTag);
    } else {
      pathSegments.push(this.subscriptionTag);
      pathSegments.push(this.channelTag);
    }
    this.pathSegments = pathSegments;

    this.navigationService.updatePathSegments(pathSegments, this.isSubDomain);
    this.channelStore.update({
      subscriptionTag: subscriptionTag,
      channelTag: channelTag,
      isSubDomain: this.isSubDomain,
      pathSegments: pathSegments
    });
  }

  getUserService(): UserService {
    if (!this.userService) {
      this.userService = this.injector.get(UserService);
    }
    return this.userService;
  }

  getCurrentRouteName() {
    const url = this.router.url.split('?')[0];
    const segments = url.split('/').filter(Boolean);
    return segments.length >= 2 && this.isSubDomain ? segments[1] : segments[2];
  }
}
